export default {
    readOnly: 'Ce profil client est en lecture seule.',
    actionContext: {
        loadFailed: 'Impossible de charger la disponibilité des actions. Veuillez réessayer.',
        preflightFailed: 'Impossible de démarrer cette action. Veuillez réessayer.',
        reasons: {
            loading: 'Vérification de la disponibilité de cette action.',
            noEligibleTargetLead: "Aucun lead admissible n'est disponible pour ce client.",
            notAuthorized: "Vous n'êtes pas autorisé à effectuer cette action.",
            preparing: 'Préparation de cette action.',
            readNotActivated: 'Les actions du profil client ne sont pas offertes pour ce compte.',
            unavailable: "Cette action n'est pas disponible pour le moment.",
            writeNotActivated: "La modification du profil client n'est pas activée pour ce compte.",
        },
    },
    contactTab: {
        address: 'Adresse',
        accessibility: {
            emailAddress: 'Adresse courriel {index}',
            emailType: 'Type de courriel {index}',
            newEmailAddress: 'Nouvelle adresse courriel',
            newEmailType: 'Nouveau type de courriel',
            newPhoneExtension: 'Nouveau poste téléphonique',
            newPhoneNumber: 'Nouveau numéro de téléphone',
            newPhoneType: 'Nouveau type de téléphone',
            phoneExtension: 'Poste téléphonique {index}',
            phoneNumber: 'Numéro de téléphone {index}',
            phoneType: 'Type de téléphone {index}',
        },
        addEmail: 'Ajouter un courriel',
        addPhone: 'Ajouter un téléphone',
        additionalContact: 'Contact additionnel',
        birthdayInDays: 'Anniversaire dans {count} jours!',
        birthdayToday: "C'est son anniversaire aujourd'hui!",
        communicationPreferences: {
            email: 'Courriel',
            phone: 'Téléphone',
            sms: 'SMS',
        },
        confirmDelete: 'Sélectionnez de nouveau pour confirmer la suppression',
        contactNumber: 'Contact {number}',
        customerType: 'Type de client',
        customerTypes: {
            business: 'Entreprise',
            person: 'Particulier',
        },
        currentCustomerType: 'Type de client : {customerType}',
        fields: {
            city: 'Ville',
            contactInformation: 'Coordonnées',
            communicationPreference: 'Préférence de contact',
            country: 'Pays',
            dateOfBirth: 'Date de naissance',
            email: 'Courriel',
            extension: 'poste {extension}',
            firstName: 'Prénom',
            gender: 'Genre',
            homeEmail: 'Courriel personnel',
            homePhone: 'Téléphone résidentiel',
            language: 'Langue',
            lastName: 'Nom',
            mobilePhone: 'Téléphone mobile',
            otherEmail: 'Autre courriel',
            postalCode: 'Code postal',
            province: 'Province',
            streetAddress: 'Adresse civique',
            streetAddress2: 'Adresse - ligne 2',
            title: 'Civilité',
            workEmail: 'Courriel professionnel',
            workPhone: 'Téléphone professionnel',
        },
        homeContact: 'Coordonnées personnelles',
        deleteEmail: 'Supprimer le courriel',
        deletePhone: 'Supprimer le téléphone',
        emailTypes: {
            home: 'Personnel',
            other: 'Autre',
            work: 'Professionnel',
        },
        emails: 'Courriels',
        extension: 'Poste',
        invalidEmail: 'Saisissez une adresse courriel valide.',
        invalidPhone: 'Saisissez un numéro canadien ou américain valide.',
        invalidContact: 'Coordonnée invalide',
        notes: 'Notes',
        noteEditorLabel: 'Notes du client',
        notePlaceholder: 'Ajouter une note à propos de ce client',
        noteSaving: 'Enregistrement de la note…',
        save: "Impossible d'enregistrer la note. Veuillez réessayer.",
        validation: 'Les notes doivent contenir au maximum 250 caractères.',
        notPreferred: 'Non préféré',
        personalDetails: 'Renseignements personnels',
        preferred: 'Préféré',
        primaryContact: 'Contact principal',
        primaryBadge: 'Principal',
        requiredEmail:
            'Une adresse courriel est requise. Utilisez la suppression pour retirer ce courriel.',
        requiredPhone:
            'Un numéro de téléphone est requis. Utilisez la suppression pour retirer ce numéro.',
        phoneTypes: {
            home: 'Résidentiel',
            mobile: 'Mobile',
            work: 'Professionnel',
        },
        phones: 'Téléphones',
        updateFailed:
            'Impossible d’enregistrer cette modification. La valeur confirmée a été conservée.',
        workContact: 'Coordonnées professionnelles',
    },
    contactDetails: {
        call: 'Appeler',
        dateOfBirth: 'Date de naissance',
        homeEmail: 'Courriel personnel',
        mobilePhone: 'Téléphone mobile',
        notes: 'Notes',
        readLess: 'Réduire',
        readMore: 'Lire la suite',
        seeAll: 'Voir tous les détails du contact',
        sendEmail: 'Envoyer un courriel',
        sms: 'SMS',
        workPhone: 'Téléphone bureau',
    },
    error: {
        loadFailed: 'Impossible de charger le profil client.',
        actionsLoadFailed: 'Les actions du lead sont indisponibles pour le moment.',
        leadDetailsLoadFailed: 'Impossible de charger les détails du lead.',
        sectionLoadFailed: 'Impossible de charger cette section.',
        retry: 'Réessayer',
    },
    header: {
        associate: 'Associé',
        customer: 'Client',
        lastContacted: 'Dernier contact',
        more: 'Plus',
        never: 'Jamais',
        noActiveLead: 'Aucun lead actif auquel ajouter une note',
        startVisit: 'Commencer la visite',
        status: 'Statut',
        unassigned: 'Non assigné',
    },
    sensitiveInfo: {
        hiddenValue: 'Valeur sensible masquée',
    },
    notes: {
        addNote: 'Ajouter une note',
        allNotes: 'Toutes les notes',
        saveError: "Impossible d'enregistrer la note. Veuillez réessayer.",
        deleteError: 'Impossible de supprimer la note. Veuillez réessayer.',
        loadNoteError: 'Impossible de charger cette note. Veuillez réessayer.',
        loadForEditError: 'Impossible de charger cette note pour la modifier. Veuillez réessayer.',
        loadForReplyError: 'Impossible de charger cette note pour y répondre. Veuillez réessayer.',
        refreshError:
            'Impossible de rafraîchir les notes. Rechargez pour voir les dernières modifications.',
    },
    sections: {
        activityFeed: "Fil d'activité",
        contactDetails: 'Détails du contact',
        sales: 'Ventes',
        service: 'Service',
        tradeIn: 'Échange',
    },
    activityFeed: {
        bookmarkUpdateFailed: 'Impossible de mettre à jour ce favori.',
        taskRefreshFailed:
            "La tâche a été terminée, mais le fil d'activité n'a pas pu être actualisé. Rechargez la page pour voir les dernières modifications.",
        search: 'Rechercher',
        datePicker: 'Sélectionner les dates',
        filters: {
            all: 'Tout',
            bookmarked: 'Favoris',
            note: 'Note',
            call: 'Appel',
            sms: 'SMS',
            email: 'Courriel',
            messenger: 'Messenger',
            video: 'Vidéo',
            appointment: 'Rendez-vous',
            task: 'Tâche',
        },
        division: {
            sales: 'Ventes',
            service: 'Service',
        },
        sections: {
            upcoming: 'À venir',
            past: 'Passé',
        },
        rollup: {
            seeAll: 'Voir les {count} éléments automatisés',
            seeLess: 'Voir moins',
        },
        timestamp: {
            yesterday: 'il y a 1 jour',
        },
        emptyState: {
            title: 'Aucune activité',
            description: "L'activité apparaîtra ici une fois les interactions enregistrées.",
        },
        inboundCall: 'Appel entrant',
        outboundCall: 'Appel sortant',
        inboundSms: 'SMS entrant',
        outboundSms: 'SMS sortant',
        inboundEmail: 'Courriel entrant',
        outboundEmail: 'Courriel sortant',
        inboundMessenger: 'Message Facebook entrant',
        outboundMessenger: 'Message Facebook sortant',
        inboundVideo: 'Appel vidéo entrant',
        outboundVideo: 'Appel vidéo sortant',
        note: 'Note',
        appointment: 'Rendez-vous',
        task: 'Tâche',
        newLead: 'Nouveau lead',
        unknownEvent: 'Activité',
        unknownEventDescription: "Ce type d'activité n'est pas encore pris en charge.",
        automated: 'Automatisé',
        receptionist: 'Réceptionniste',
        private: 'Privé',
        newMessage: 'Nouveau message',
        noteReply: 'Réponse à une note',
        newLeadReceived: 'Un nouveau lead a été reçu pour ce client.',
        source: 'Source',
        form: 'Formulaire',
        comments: 'Commentaires',
        confirmed: 'Confirmé',
        canceled: 'Annulé',
        noShow: 'Absent',
        overdue: 'En retard',
        callStatus: {
            answered: 'Répondu',
            attempted: 'Tentative',
            calling: 'Appel en cours',
            delivery_failed: 'Échec de transmission',
            error: 'Erreur',
            interrupted: 'Interrompu',
            invalid: 'Invalide',
            pending: 'En attente',
            unanswered: 'Sans réponse',
            voicemail: 'Messagerie vocale',
        },
        actions: {
            reply: 'Répondre',
            view: 'Voir',
            viewSourceDetails: 'Voir les détails de la source',
            viewLead: 'Voir le lead',
            markAsComplete: 'Marquer comme terminé',
            markAsRead: 'Marquer comme lu',
        },
        view: {
            communicationUnavailable:
                "Il n'est plus possible d'ouvrir cette activité. Veuillez réessayer.",
            staleMobilePhone:
                "Ce SMS utilisait un numéro de téléphone qui n'est plus disponible pour ce client.",
            callTitle: "Détails de l'appel",
            emailTitle: 'Courriel du lead Web',
            messengerTitle: 'Détails Messenger',
            noSubject: '(Sans objet)',
            apiSource: 'API',
            userSource: 'Utilisateur',
        },
        reply: {
            communicationUnavailable:
                "Il n'est plus possible de répondre à cette activité. Veuillez réessayer.",
            noCurrentEmail:
                "Le courriel est indisponible, car le client n'a aucune adresse courriel actuelle valide.",
            noCurrentMobilePhone:
                "Le SMS est indisponible, car le client n'a aucun numéro mobile actuel valide sur ce lead.",
            legacyPhoneSelectionUnavailable:
                "Cette activité SMS utilisait un ancien numéro et l'ancienne messagerie SMS ne peut pas ouvrir un numéro actuel précis. Aucune conversation n'a été ouverte.",
            emailMismatch:
                "L'adresse utilisée pour cette activité ne correspond plus aux données actuelles du client. Choisissez une adresse actuelle pour continuer.",
        },
    },
    status: {
        pending: 'En attente',
        attempted: 'Tentative',
        reached: 'Rejoint',
        engaged: 'Engagé',
        needsAttention: 'Attention requise',
    },
    sales: {
        seeAllLeads: 'Voir tous les leads',
        viewSourceDetails: 'Voir les détails de la source',
        noLeads: 'Aucun lead pour le moment',
        addNewLead: 'Ajouter un nouveau lead',
        bdcAgent: 'Agent BDC',
        fniManager: 'Directeur F&I',
        secondAssociate: 'Second associé',
        progressSteps: {
            vehicle: 'Véhicule',
            tradeIn: 'Échange',
            visit: 'Visite',
            sale: 'Vente',
            credit: 'Crédit',
            delivery: 'Livraison',
        },
    },
    currentLeads: {
        title: 'Leads actifs',
        merged: '{count} leads fusionnés',
        lastUpdated: 'Dernière mise à jour',
        addedOn: 'Ajouté le',
        emptyVehicles: "Aucun véhicule d'intérêt n'est disponible pour ce lead.",
        noMatchingVehicles: 'Aucun véhicule ne correspond aux filtres sélectionnés.',
        actions: {
            addLead: 'Ajouter un lead',
            hideSensitive: 'Masquer les informations sensibles',
            showSensitive: 'Afficher les informations sensibles',
            viewSourceDetails: 'Voir les détails de la source',
            findMatches: 'Trouver des correspondances',
            open: 'Ouvrir le lead',
            share: 'Partager le lead',
            print: 'Imprimer le lead',
            export: 'Exporter le lead',
            expand: 'Développer les détails du lead',
            collapse: 'Réduire les détails du lead',
            addVehicle: 'Ajouter un véhicule',
            filterSort: 'Filtrer et trier',
            viewPricing: 'Voir le prix',
            vehicleDetails: 'Détails du véhicule',
            actions: 'Actions',
        },
        progress: {
            vehicle: "Véhicule d'intérêt",
            tradeIn: 'Échange',
            visit: 'Visite',
            sale: 'Vente',
            credit: 'Crédit',
            creditAndFi: 'Crédit et F&I',
            delivery: 'Livraison',
        },
        workflow: {
            loading: 'Chargement du flux de travail du lead…',
            openError: "Impossible d'ouvrir ce flux de travail pour le lead sélectionné.",
            retry: 'Réessayer',
        },
        assignment: {
            loading: 'Chargement des assignations…',
            openError: 'Impossible de charger les assignations pour le lead sélectionné.',
            retry: 'Réessayer',
            saveError: 'Impossible de mettre à jour cette assignation. Veuillez réessayer.',
        },
        matching: {
            title: 'Attribution du parcours de vente',
            journeyCount: '{count} événements du parcours',
            opportunityTitle: 'Opportunité de vente de {name}',
            mergedLeads: '{count} leads fusionnés',
            potentialMatches:
                'Correspondances potentielles à attribuer à l’opportunité de vente de {name}',
            addToDeal: 'Ajouter à la transaction',
            loading: 'Chargement des leads correspondants…',
            openError: 'Impossible de trouver des correspondances pour le lead sélectionné.',
            candidatesError: 'Impossible de charger les leads correspondants.',
            empty: 'Aucun lead correspondant admissible n’a été trouvé.',
            retry: 'Réessayer',
            complete: 'Les {count} leads ont été ajoutés au parcours de vente.',
            partial: "{count} leads ont été ajoutés avant l'arrêt de l'attribution.",
            failed: "Aucun lead n'a été ajouté au parcours de vente.",
        },
        output: {
            title: {
                share: 'Partager le document du lead',
                print: 'Imprimer le document du lead',
                export: 'Exporter le lead',
            },
            close: 'Fermer les options du document',
            loading: 'Chargement du document du lead sélectionné…',
            openError: 'Impossible de charger les options pour le lead sélectionné.',
            retry: 'Réessayer',
            share: {
                selectTemplate: 'Sélectionnez un modèle PDF à partager.',
                generationError:
                    'Impossible de générer le PDF. Sélectionnez un modèle pour réessayer.',
            },
            reasons: {
                contact_profile_reads_disabled:
                    'Les données de contact canoniques ne sont pas disponibles pour ce compte.',
                missing_primary_mapping: "Ce lead n'est pas lié à un contact principal.",
                inactive_primary_mapping:
                    'Le lien vers le contact principal de ce lead est inactif.',
                conflicting_primary_mapping:
                    'Ce lead comporte des liens conflictuels vers le contact principal.',
                missing_primary_contact: 'Le contact principal lié à ce lead est indisponible.',
                ownership_scope_violation:
                    "Le lead et le contact sélectionnés n'appartiennent pas au même compte client.",
                missing_advisor:
                    "Assignez un conseiller aux ventes avant l'exportation vers ce fournisseur.",
                missing_email: 'Ajoutez une adresse courriel client valide avant de partager.',
                invalid_email:
                    "L'adresse courriel du client est invalide. Ajoutez une adresse valide avant de partager.",
                missing_email_projection:
                    "L'adresse courriel du client n'est pas prête pour un envoi à partir de ce lead.",
                missing_phone:
                    'Ajoutez un numéro de téléphone client valide avant cette exportation.',
                invalid_phone:
                    'Le numéro de téléphone du client est invalide. Ajoutez un numéro valide avant cette exportation.',
                missing_personal_data: 'Ajoutez le nom du client requis avant cette exportation.',
                missing_wanted_vehicle:
                    "Ajoutez un véhicule recherché avant l'exportation vers ce fournisseur.",
            },
        },
        status: {
            active: 'Actif',
        },
        assignees: {
            salesAssociate: 'Conseiller aux ventes',
            bdcAgent: 'Agent BDC',
            secondAssociate: 'Second associé',
            fiManager: 'Directeur F&I',
        },
        vehicle: {
            stock: 'Stock no',
            vin: 'NIV',
            payment: 'Paiement',
            rate: 'Taux',
            term: 'Terme',
            months: 'mois',
            apr: 'TAP',
        },
        modality: {
            financing: 'Financement',
            leasing: 'Location',
            cash: 'Comptant',
        },
        frequency: {
            weekly: 'Hebdomadaire',
            bi_weekly: 'Aux deux semaines',
            semi_monthly: 'Bimensuel',
            monthly: 'Mensuel',
        },
        empty: {
            title: 'Aucun lead actif',
            description: 'Les leads de vente actifs apparaîtront ici une fois ajoutés.',
        },
    },
    pastLeads: {
        title: 'Leads passés',
        status: {
            delivered: 'Livré',
            lost: 'Perdu',
            duplicate: 'Doublon',
            invalid: 'Invalide',
        },
        actions: {
            expand: 'Développer les détails du lead',
            collapse: 'Réduire les détails du lead',
        },
        detail: {
            loading: 'Chargement des détails du lead…',
            error: 'Impossible de charger les détails de ce lead.',
            retry: 'Réessayer',
        },
        empty: {
            title: 'Aucun lead passé',
            description:
                'Les leads de vente passés apparaîtront ici lorsqu’ils seront disponibles.',
        },
    },
    service: {
        title: 'Leads de service',
        seeAllLeads: 'Voir tous les leads de service',
        viewSourceDetails: 'Voir les détails de la source',
        noLeads: 'Aucun lead de service pour le moment',
        addNewLead: 'Ajouter un nouveau lead de service',
        addLeadUnavailable: 'Impossible de démarrer la création du lead de service.',
        serviceAgent: 'Agent de service',
        serviceAdvisor: 'Conseiller de service',
        filters: {
            vehicle: 'Sélectionner des véhicules',
            dateRange: 'Plage de dates',
        },
        table: {
            sourceType: 'Type de source',
            dateTime: 'Date et heure',
            leadStatus: 'Statut du lead',
            advisor: 'Conseiller',
            vehicle: 'Véhicule',
        },
        groups: {
            upcoming: 'Leads de service à venir',
            past: 'Leads de service passés',
        },
        statuses: {
            reached: 'Rejoint',
            noShow: 'Absent',
            completed: 'Terminé',
            canceled: 'Annulé',
        },
        vehiclePopover: {
            equity: 'Équité',
            appraisalValue: "Valeur d'évaluation",
            payment: 'Paiement',
            positive: 'Positive',
            negative: 'Négative',
            term: '{count} mois',
            frequency: {
                bi_weekly: 'deux semaines',
                weekly: 'semaine',
                monthly: 'mois',
                semi_monthly: 'demi-mois',
            },
        },
        progressSteps: {
            appointmentScheduled: 'Rendez-vous planifié',
            clientVisited: 'Client visité',
            plannedPickUp: 'Cueillette planifiée',
            invoiced: 'Facturé',
        },
    },
    tradeIn: {
        noVehicles: "Aucun véhicule d'échange ajouté",
        vehicleDetails: 'Détails du véhicule',
        openTradeInError: "Impossible d'ouvrir l'échange pour ce lead.",
        vin: 'NIV',
        appraisalValue: "Valeur d'évaluation",
        payments: 'Paiements',
        contractEndDate: 'Fin du contrat',
        equity: 'Équité',
        frequency: {
            weekly: 'Hebdomadaire',
            bi_weekly: 'Aux deux semaines',
            semi_monthly: 'Bimensuel',
            monthly: 'Mensuel',
        },
        modality: {
            financing: 'Financement',
            leasing: 'Location',
            cash: 'Comptant',
        },
    },
    tabs: {
        comingSoon: 'À venir',
        overview: 'Aperçu',
        sales: 'Ventes',
        service: 'Service',
        contact: 'Contact',
        history: 'Historique',
    },
};
